<template>
  <div>
      <div v-if="hasSupplier">
        <b-row v-for="(supplier, index) in supplierList" v-bind:key="index">
            <b-col sm="5">
                <b-badge
                    pill
                    variant="primary"
                >{{supplier.supplier}}</b-badge>
            </b-col>
            <b-col sm="2">
                <b-badge
                    pill
                    variant="primary"
                    v-b-tooltip.hover.right="'Temps d\'attente moyen de la carte'"
                >{{step[supplier.supplier].to_next_idle}}</b-badge>
            </b-col>
        </b-row>
      </div>
    <link-info v-else :info="step.to_next_idle"
    id="waiting-time"
    v-b-tooltip.hover.top="'Temps d\'attente moyen de la carte'"

    />
    <div>
      <div class="hyppo-item">
        <p>{{step.display}}</p>
        <b-badge
          pill
          variant="info"
          v-b-tooltip.hover.right="'Nbre de cartes concernées'"
        >{{step.cards.length}} sur {{reference.nbr_card}}</b-badge>
      </div>
      <hippo-card-list
        id="hippo-card-list"
        :class="{'hippo-left': listPosition =='left',
                 'hippo-bottom': listPosition =='bottom',
                 'hippo-right': listPosition =='right'}"
        :items="step.cards"
      />
      <div>
        <bl-list
          v-if="bllist"
          class="bl-list"
          :items="bllist"
        />
      </div>
    </div>
  </div>
</template>
<script>

// import server from '../../api/server.vue'
// import { mapGetters } from 'vuex'
import BlList from '../detailed/BlList.vue'
import HippoCardList from '../detailed/HippoCardList.vue'
import LinkInfo from '../detailed/LinkInfo.vue'

export default {
  name: 'WorkstationItem',
  props: ['reference', 'step', 'bllist', 'listPosition', 'supplierList'],
  data() {
    return {
        hasSupplier: false
    };
  },
  computed: {
  },
  methods: {
  },
  mounted: function () {
      if (this.supplierList !== undefined) {
          this.hasSupplier = true
      }
  },
  components: { HippoCardList, BlList, LinkInfo }
  // eslint-disable-next-line
};
</script>

<style type="text/css" scoped>
.hyppo-item {
  width: 115px;
  height: 115px;
  background-image: url('../../../assets/base_blue.png');
  background-size: contain;
  background-repeat: no-repeat;
}
.hyppo-item .badge {
  padding-top: 10px;
  font-size: 1.2em;
}
.hyppo-item p {
  padding-top: 40px;
  font-size: 1.2em;
  font-weight: bold;
}
#hippo-card-list {
  position: absolute;
  /*width: 500px;*/
  /*top: 0px;
  left: -250px;*/
}
.hippo-bottom {
  top: 160px;
  left: -50px;
  width: 250px;
}
.hippo-left {
  top: 0px;
  left: -250px;
}
.hippo-right {
  top: 0px;
  left: 150px;
  min-width: 250px;
}
#waiting-time {
  position: absolute;
  top: -5px;
  left: 30px;
}
.card-list {
  position: absolute;
  /*width: 500px;*/
  top: 140px;
  left: -50px;
}
</style>



// WEBPACK FOOTER //
// src/components/andon/hippodrome/WorkstationItem.vue